import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { snakeCase } from 'lodash';

import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './sov-teaser-consumer-insights.scss';

applyTranslations(require('./sov-teaser-consumer-insights.i18n.json'));

type Props = {};

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['strong']
};

const MSG_KEY = 'sov_teaser_consumer_insights';

class SOVTeaserConsumerInsights extends React.PureComponent<Props> {
  renderHeader(): React.ReactNode {
    return (
      <div
        className="sov-teaser-consumer-insights__header"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(__t(`${MSG_KEY}.header`), SANITIZE_HTML_CONFIG)
        }}
      />
    );
  }

  renderFooter(): React.ReactNode {
    return (
      <div className="sov-teaser-consumer-insights__footer">
        <ActionButton
          color="primary"
          link={`mailto:${__t(`${MSG_KEY}.links.email`)}`}
          className="sov-teaser-consumer-insights__button"
        >
          {__t(`${MSG_KEY}.buttons.contact`)}
        </ActionButton>
        <a
          href={__t(`${MSG_KEY}.links.site`)}
          target="_blank"
          rel="noopener noreferrer"
          className="sov-teaser-consumer-insights__link"
        >
          {__t(`${MSG_KEY}.links.visit`)}
        </a>
      </div>
    );
  }

  renderBody(): React.ReactNode {
    const items = [
      { key: 'channel-info' },
      { key: 'mention-card' },
      { key: 'audience-data' }
    ];

    return (
      <div className="sov-teaser-consumer-insights__body">
        {
          items.map(item => (
            <React.Fragment key={`sov-teaser-consumer-insights--item-${item.key}`}>
              <div className="sov-teaser-consumer-insights__body-message">
                {__t(`${MSG_KEY}.messages.${snakeCase(item.key)}`)}
              </div>
              <div className="sov-teaser-consumer-insights__body-image">
                <img
                  data-src={`/static/images/ci-sov-${item.key}.svg`}
                  className="lazyload"
                  alt={__t(`${MSG_KEY}.messages.${item.key}`)}
                />
              </div>
            </React.Fragment>
          ))
        }
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="sov-teaser-consumer-insights">
        {this.renderHeader()}
        {this.renderBody()}
        {this.renderFooter()}
      </div>
    );
  }
}

export default SOVTeaserConsumerInsights;
